import Box from 'components/Box';
import { TurnType } from 'features/turn/pages/constanst';
import { TurnFeaturesContainer } from 'features/turn/pages/TurnManualUI/TurnFooter/TurnFeatures';
import { TURN_ITEM_TYPE } from 'features/turn/services/constants';
import { turnManualSelectors } from 'features/turn/services/selectors';
import { useMemo } from 'react';
import styled from 'styled-components';
type Props = {
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
};
const TypeOptions = ({ value, onChange, disabled }: Props) => {
  const turnSettingColors = turnManualSelectors.settingColors();
  const handleOnChange = (_value: string) => {
    switch (_value) {
      case TURN_ITEM_TYPE.WALK_IN:
        onChange?.(TurnType.WALK_IN);
        break;
      case TURN_ITEM_TYPE.APPOINTMENT:
        onChange?.(TurnType.APPOINTMENT);
        break;
      case TURN_ITEM_TYPE.BONUS:
        onChange?.(TurnType.BONUS);
        break;
      case TURN_ITEM_TYPE.REQUEST:
        onChange?.(TurnType.REQUEST);
        break;
      default:
        break;
    }
  };

  const _value = useMemo(() => {
    switch (value) {
      case TurnType.WALK_IN:
        return TURN_ITEM_TYPE.WALK_IN;
      case 'WALK_IN':
        return TURN_ITEM_TYPE.WALK_IN;
      case TurnType.APPOINTMENT:
        return TURN_ITEM_TYPE.APPOINTMENT;
      case TurnType.BONUS:
        return TURN_ITEM_TYPE.BONUS;
      case TurnType.REQUEST:
        return TURN_ITEM_TYPE.REQUEST;
    }
  }, [value]);

  const onChangeType = (type: TURN_ITEM_TYPE) => () => handleOnChange(type);

  return (
    <Container className='TurnTypes small' turnSettingColors={turnSettingColors}>
      <button disabled={disabled} onClick={onChangeType(TURN_ITEM_TYPE.WALK_IN)} type='button' className="btn WALK_IN">
        <div className="box-item WALK_IN"></div>
        <div className="label-type">WALK-IN</div>
        {_value === TURN_ITEM_TYPE.WALK_IN && <div className='icon-active'>{iconCheck}</div>}
      </button>
      <button disabled={disabled} onClick={onChangeType(TURN_ITEM_TYPE.APPOINTMENT)} type='button' className="btn APPOINTMENT">
        <div className="box-item APPOINTMENT"></div>
        <div className="label-type">APPT.</div>
        {_value === TURN_ITEM_TYPE.APPOINTMENT && <div className='icon-active'>{iconCheck}</div>}
      </button>
      <button disabled={disabled} onClick={onChangeType(TURN_ITEM_TYPE.BONUS)} type='button' className="btn BONUS">
        <div className="box-item BONUS"></div>
        <div className="label-type">Bonus</div>
        {_value === TURN_ITEM_TYPE.BONUS && <div className='icon-active'>{iconCheck}</div>}
      </button>
      <button disabled={disabled} onClick={onChangeType(TURN_ITEM_TYPE.REQUEST)} type='button' className="btn REQUEST">
        <div className="box-item REQUEST"></div>
        <div className="label-type">REQUEST</div>
        {_value === TURN_ITEM_TYPE.REQUEST && <div className='icon-active'>{iconCheck}</div>}
      </button>
    </Container>
  );
};

export default TypeOptions;

const Container = styled(TurnFeaturesContainer)`
align-self: stretch;
&.small {
  display: flex;
  flex-direction: row;
  .btn {
    flex: 1;
    height: 50px;
    position: relative;
    .box-item {
      width: 35px;
      height: 35px;
    }
    .label-type {
      font-size: 14px;
    }
    .icon-active {
      position: absolute;
      top: -8px;
      right: -8px;
    }
  }
}
`;

const iconCheck = <Box display='flex' alignItems='center' justifyContent='center' style={{ borderRadius: 25, width: 25, height: 25, background: '#00AD45' }}>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M6.48494 12C6.2715 12 6.06873 11.9107 5.91932 11.7544L2.89911 8.59574C2.58962 8.27206 2.58962 7.73631 2.89911 7.41263C3.20859 7.08894 3.72085 7.08894 4.03033 7.41263L6.48494 9.97977L11.9703 4.24276C12.2798 3.91908 12.7921 3.91908 13.1015 4.24276C13.411 4.56645 13.411 5.1022 13.1015 5.42588L7.05055 11.7544C6.90114 11.9107 6.69838 12 6.48494 12Z" fill="white" />
  </svg>
</Box>;
